/** Mixed exams build on national-exam or university courses; ordinary schools have neither. */
export function canUseMixedExam(role: string | null | undefined, user: { is_hub_admin?: boolean; institution_type?: string | null } | undefined) {
  if (role === 'superuser' || user?.is_hub_admin) return true;
  const t = String(user?.institution_type ?? '').toLowerCase();
  return role === 'college_university' || t.includes('college') || t.includes('university');
}
